
import React from 'react'
import '../styles/Header.css'

export default function Header(){

	return (<div>

			<div id='heading'>	

					<div id='acronym'>AK |</div> 

					<div class='anna'> ANNA KAY WILLIAMS <div class='realty'> REALITY</div>	</div>


			</div>



			</div>)


}